import http from "@/http-common"

class CommentDataService {
    getAll(url) {
        return http.get(`comments${ url }`)
    }

    get(id) {
        return http.get(`comments/${ id }`)
    }

    post(data) {
        return http.post('comments', data)
    }

    patch(id, data, headers) {
        return http.patch(`comments/${ id }`, data, headers)
    }

    delete(id) {
        return http.delete(`comments/${ id }`)
    }
}

export default new CommentDataService()